import styled from '@emotion/styled';

export const BadgeText = styled.div`
  z-index: 1;
  font-size: 1rem;
  color: #fff;
  padding-left: 16px;
  font-weight: 400;
  line-height: 1;
  flex-grow: 1;

  > b {
    font-size: 24px;
    font-weight: 700;
    display: block;
    white-space: nowrap;
    padding: 2px 0;
  }
`;
